module.exports = __webpack_public_path__ + "static/media/jt10.1ca047c3.png";